import { useQuery } from 'react-query';
import { livePredictionWsAxiosApi } from 'src/Config/axiosApi';
import { PredictionOpportunity } from '../types';

interface OpportunitiesSnapshotResponse {
  data: PredictionOpportunity[];
  count: number;
  timestamp: number;
}

/**
 * Mirror of useOpportunitiesSnapshot, but targets the live WS service
 * (Phase 3 of the live-events pipeline). Same race-avoidance rationale: the
 * gateway emits `prediction_snapshot` inside handleConnection before the
 * React-side socket.io-react-hook listener installs, so we seed the cache
 * via REST and let the WS push deltas from there.
 *
 * The endpoint path is identical to the regular WS (`/predictions/opportunities`)
 * — the live deployment is the same image, just with LIVE_MODE=true, so its
 * cache only ever contains live opportunities.
 */
export function useLiveOpportunitiesSnapshot(enabled: boolean) {
  return useQuery<OpportunitiesSnapshotResponse>(
    ['live-prediction-opportunities-snapshot'],
    async () => {
      const { data } =
        await livePredictionWsAxiosApi.get<OpportunitiesSnapshotResponse>(
          '/predictions/opportunities'
        );
      return data;
    },
    {
      enabled,
      staleTime: 0,
      cacheTime: 0,
      refetchOnWindowFocus: false
    }
  );
}
